import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import { default as webRouter } from '@/modules/workOnline/router'
import { default as mobileRouter } from '@/modules/officialAccounts/router'
import { Dialog, Notify } from 'vant'
import theme from '@/styles/theme.scss'

const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'

const service = axios.create({
  baseURL: projectConfig.baseURL,
  timeout: 8000
})

service.interceptors.request.use(
  config => {
    const expireTime = localStorage.getItem('expireTime')
    if (expireTime) {
      const currentTime = new Date().getTime()
      const timeDiff = (expireTime - currentTime) / 1000 / 60 // 分钟
      if (timeDiff > 0 && timeDiff < 20) {
        axios.get(projectConfig.baseURL + '/bd/user/refreshToken', {
          headers: { 'token': localStorage.getItem('sys_token') }
        }).then(res => {
          const { token, expireTime } = res.data.data
          localStorage.setItem('sys_token', token)
          localStorage.setItem('expireTime', expireTime)
        })
      }
    }
    config.headers.token = localStorage.getItem('sys_token')
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(response => {
  const res = response.data
  if (res.code && res.code !== 2000 && res.code !== 200) {
    switch (res.code) {
      case 4010:
        localStorage.removeItem('sys_token')
        localStorage.removeItem('userInfo')
        if (isMobile) {
          window.location.href = projectConfig.jumpURL + '/mobile'
          // mobileRouter.push('/') // 移动端首页本地调试
        } else {
          // window.location.href = projectConfig.jumpURL
          webRouter.push('/') // PC端首页本地调试
          window.location.reload()
        }
        break
      case 999:
        if (isMobile) {
          return Promise.reject(Notify({
            message: '发送失败',
            type: 'warning',
          }))
        } else {
          return Promise.reject(Message({
            message: '发送失败',
            type: 'warning',
          }))
        }
      default:
        if (isMobile) {
          return Promise.reject(Notify({
            message: res.message || res.msg,
            type: 'warning',
          }))
        } else {
          return Promise.reject(Message({
            message: res.message || res.msg,
            type: 'warning',
          }))
        }
    }
  } else {
    return res
  }
}, error => {
  if (isMobile) {
    return Promise.reject(Notify({
      message: '请求失败，请刷新页面或联系管理员',
      type: 'warning',
    }))
  } else {
    return Promise.reject(Message({
      message: '请求失败，请刷新页面或联系管理员',
      type: 'warning',
    }))
  }
})

export default service